"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var swr_hooks_1 = require("@l2p/swr-hooks");
var navigation_1 = require("next/navigation");
var react_1 = __importDefault(require("react"));
var index_1 = require("../index");
var Copyright_1 = __importDefault(require("./Copyright"));
var Disclaimer_1 = __importDefault(require("./Disclaimer"));
var FooterMenu_1 = __importDefault(require("./FooterMenu"));
var MadeBy_1 = __importDefault(require("./MadeBy"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Footer = function (_a) {
    var defaultCurrency = _a.defaultCurrency, restrictedLicenseCountries = _a.restrictedLicenseCountries, footerMenu = _a.footerMenu, languages = _a.languages, _b = _a.withDividedLines, withDividedLines = _b === void 0 ? false : _b, _c = _a.poweredBy, poweredBy = _c === void 0 ? true : _c, _d = _a.License, License = _d === void 0 ? null : _d, _e = _a.LicenseWidget, LicenseWidget = _e === void 0 ? null : _e;
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var pathname = (0, navigation_1.usePathname)();
    if (pathname.includes('game-not-available')) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    // @ts-ignore
    return !pathname.includes('/game/') ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container, style: { paddingBottom: !isAuth ? '60px' : '0' } },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.mainFooter },
                react_1.default.createElement(FooterMenu_1.default, { languages: languages, footerMenu: footerMenu, restrictedLicenseCountries: restrictedLicenseCountries, LicenseWidget: LicenseWidget }),
                poweredBy && react_1.default.createElement(MadeBy_1.default, null),
                react_1.default.createElement(Copyright_1.default, { restrictedLicenseCountries: restrictedLicenseCountries, License: License }),
                react_1.default.createElement(Disclaimer_1.default, null))),
        react_1.default.createElement(index_1.AcceptCookies, null),
        react_1.default.createElement(index_1.GetBonusPanel, null),
        react_1.default.createElement(index_1.MobileAuthButtons, null))) : null;
};
exports.default = Footer;
